import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import classnames from 'classnames';
import { Dropdown, Checkbox } from "semantic-ui-react";
import DatePicker, { registerLocale } from "react-datepicker";
import ru from 'date-fns/locale/ru';

import RequireAuth from "../../layout/HOC/require-auth";
import SvgSpinner from "../../ui/SvgSpinner/SvgSpinner";
import DatepickerInput from "./DatepickerInput/DatepickerInput";

import "react-datepicker/dist/react-datepicker.css";
import "./Analytics.scss";

import {
  getAnalyticsFileAsync,
  getFilterDataAsync,
  changeReportType,
  changeDateRange,
  changeCheckedUserTags,
  changeCheckedContentTypes,
  switchAllUserTags,
  switchAllContentTypes,
} from "../../../redux/actions/analytics";

registerLocale("ru", ru); // register it with the name you want

const mapStateToProps = state => ({
  ...state.analytics,
});

const mapDispatchToProps = dispatch => ({
  getAnalyticsFile: () => dispatch(getAnalyticsFileAsync()),
  getFilterData: () => dispatch(getFilterDataAsync()),
  onChangeReportType: (e, { value }) => dispatch(changeReportType(value)),
  onChangeDateRange: update => dispatch(changeDateRange(update)),
  changeCheckedUserTags: (index, newCheckedUserTagIds) => dispatch(changeCheckedUserTags(index, newCheckedUserTagIds)),
  changeCheckedContentTypes: (index, newCheckedContentTypes) => dispatch(changeCheckedContentTypes(index, newCheckedContentTypes)),
  switchAllUserTags: (newUserTags, newCheckedUserTagIds) => dispatch(switchAllUserTags(newUserTags, newCheckedUserTagIds)),
  switchAllContentTypes: (newContentTypes, newCheckedContentTypes) => dispatch(switchAllContentTypes(newContentTypes, newCheckedContentTypes)),
});

const typesList = [
  { key: 1, text: "Кол-во Консультантов и Клиентов", value: 'registrations' },
  { key: 2, text: "Кол-во Клиентов у Консультанта", value: 'consultantsclients' },
  { key: 3, text: "Информация по Клиентам", value: 'clients' },
  { key: 4, text: "Кол-во Клиентов по статусам", value: 'clientsonline' },
  { key: 5, text: "Информация по Ленте", value: 'feedstat' },

];

class Analytics extends Component {
  static propTypes = {
    filtersLoading: PropTypes.bool.isRequired,
    reportLoading: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    dateRange: PropTypes.array.isRequired,
    filterdata: PropTypes.object.isRequired,
    checkedUserTagIds: PropTypes.array.isRequired,
    checkedContentTypes: PropTypes.array.isRequired,
    getFilterData: PropTypes.func.isRequired,
    onChangeReportType: PropTypes.func.isRequired,
    onChangeDateRange: PropTypes.func.isRequired,
    changeCheckedUserTags: PropTypes.func.isRequired,
    changeCheckedContentTypes: PropTypes.func.isRequired,
    switchAllUserTags: PropTypes.func.isRequired,
    switchAllContentTypes: PropTypes.func.isRequired,
    getAnalyticsFile: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {
      formWasSent: false,
      validationError: false,
    }
  }

  componentDidMount = () => { 
    const { getFilterData } = this.props;
    getFilterData();
  }

  //Отправка данных, загрузка файла отчета с сервера
  onSubmitForm = () => {
    const { getAnalyticsFile } = this.props;
    const validationError = this.validateForm();
    this.setState({ formWasSent: true });
    if (!validationError) getAnalyticsFile();
  }

  validateForm = () => {
    const { type, dateRange, checkedUserTagIds, checkedContentTypes } = this.props;
    if ((type.length === 0) || (dateRange[0] === null) || (dateRange[1] === null)
      || ((type === 'clientsonline') && (checkedUserTagIds.length === 0))
      || ((type === 'feedstat') && (checkedContentTypes.length === 0))
    ) return true;
    return false;
  }

  //Переключение чекбокса типа клиента
  onChangeUserTagCheckbox = (userTag, index) => {
    const { checkedUserTagIds, changeCheckedUserTags } = this.props;
    //Проверим, есть ли данный элемент в списке выбранных userTag
    //Если есть, удалим его, а если нет, добавим
    const newCheckedUserTagIds = checkedUserTagIds;
    const currentUserTagId =  userTag ? userTag.id : null;
    const findCurrentIndex = checkedUserTagIds.findIndex(id => id === currentUserTagId);
    if (findCurrentIndex > -1) newCheckedUserTagIds.splice(findCurrentIndex, 1);
    else newCheckedUserTagIds.push(currentUserTagId);
    changeCheckedUserTags(index, newCheckedUserTagIds);
  }

  //Переключение чекбокса типа контента
  onChangeContentTypeCheckbox = (contentType, index) => {
    const { checkedContentTypes, changeCheckedContentTypes } = this.props;
    //Проверим, есть ли данный элемент в списке выбранных contentType
    //Если есть, удалим его, а если нет, добавим
    const newCheckedContentTypes = checkedContentTypes;
    const currentContentType = contentType ? contentType.value : '';
    const findCurrentIndex = checkedContentTypes.findIndex(type => type === currentContentType);
    if (findCurrentIndex > -1) newCheckedContentTypes.splice(findCurrentIndex, 1);
    else newCheckedContentTypes.push(currentContentType);
    changeCheckedContentTypes(index, newCheckedContentTypes);
  }

  //Выбрать все или очистить все чекбоксы типа клиента
  //selectAll === true: выбрать все
  //selectAll === false: очистить все
  onSwitchAllUserTags = selectAll => {
    const { checkedUserTagIds, filterdata, switchAllUserTags } = this.props;
    let newCheckedUserTagIds = [];
    //Выбрать все - и уже выбрано меньше, чем все
    //Сформируем newCheckedUserTagIds. Для "очистить все" он будет пустым
    if (selectAll && checkedUserTagIds.length < filterdata.userTags.length) {
      newCheckedUserTagIds = filterdata.userTags.map(item => { return item.id; });
    }
    //Cформируем newUserTags
    const newUserTags = filterdata.userTags.map(item => {
      item.checked = selectAll;
      return item;
    });
    switchAllUserTags(newUserTags, newCheckedUserTagIds);
  }

  //Выбрать все или очистить все чекбоксы типа контента
  //selectAll === true: выбрать все
  //selectAll === false: очистить все
  onSwitchAllContentTypes = selectAll => {
    const { checkedContentTypes, filterdata, switchAllContentTypes } = this.props;
    let newCheckedContentTypes = [];
    //Выбрать все - и уже выбрано меньше, чем все
    //Сформируем newCheckedContentTypes. Для "очистить все" он будет пустым
    if (selectAll && checkedContentTypes.length < filterdata.contentTypes.length) {
      newCheckedContentTypes = filterdata.contentTypes.map(item => { return item.value; });
    }
    //Cформируем newContentTypes
    const newContentTypes = filterdata.contentTypes.map(item => {
      item.checked = selectAll;
      return item;
    });
    switchAllContentTypes(newContentTypes, newCheckedContentTypes);
  }

  //Рендер списка чекбоксов типов клиентов
  renderUserTags = (userTag, i) => {
    return(
      <div key={`${userTag.name}_${i}`} className="filters-list-item">
        <Checkbox
          label={userTag.name}
          checked={userTag.checked}
          onChange={() => this.onChangeUserTagCheckbox(userTag, i)}
        />
      </div>
    );
  }

  //Рендер списка чекбоксов типа контента
  renderContentTypes = (contentType, i) => {
    return(
      <div key={`${contentType}_${i}`} className="filters-list-item">
        <Checkbox
          label={contentType.label}
          checked={contentType.checked}
          onChange={() => this.onChangeContentTypeCheckbox(contentType, i)}
        />
      </div>
    );
  }

  render() {
    const {
      type,
      dateRange,
      filterdata,
      filtersLoading,
      reportLoading,
      onChangeReportType,
      onChangeDateRange,
      checkedUserTagIds,
      checkedContentTypes,
    } = this.props;
    const { formWasSent } = this.state;
    const [startDate, endDate] = dateRange;

    //Отображение ошибок
    const reportError = (type.length === 0);
    const dateError = ((startDate === null) && (endDate === null));
    const userTagsError = ((type === 'clientsonline') && (checkedUserTagIds.length === 0));
    const contentTypesError = ((type === 'feedstat') && (checkedContentTypes.length === 0));

    const dropdownRowClass = classnames({
      'form-row': true,
      'mini': true,
      'error': formWasSent && reportError,
    });

    const dateRowClass = classnames({
      'form-row': true,
      'mini': true,
      'error': formWasSent && dateError,
    });

    return (
      <div className="page-wrapper">
        {!filtersLoading ? (
          <React.Fragment>
            <div className="page-header" /> 
            <div className="page-content forms analytics">
              <div className="form-header">Аналитика</div>
              <div className="header-info">Экспорт данных из системы. Выберите параметры экспорта</div>
              <div className="form-wrap">
                <div className="filters-row">
                  {/* Выбор типа отчета */}
                  <div className={dropdownRowClass}>
                    <label htmlFor="">Отчет</label>
                    <Dropdown
                      placeholder="Не выбрано"
                      options={typesList}
                      onChange={onChangeReportType}
                      value={type}
                      fluid
                      selection
                      selectOnBlur={false}
                      selectOnNavigation={false}
                      noResultsMessage='Совпадений не найдено'
                    />
                    {(formWasSent && reportError) ? (
                      <div className="input-text">Выберите отчет</div>
                    ) : false}
                  </div>

                  {/* Выбор даты или промежутка дат */}
                  <div className={dateRowClass}>
                    <label htmlFor="">Дата</label>
                    <DatePicker
                      locale={ru}
                      selectsRange
                      dateFormat="dd.MM.yyyy"
                      startDate={startDate}
                      endDate={endDate}
                      maxDate={new Date()}
                      customInput={<DatepickerInput />}
                      onChange={(update) => { onChangeDateRange(update); }}
                      placeholderText="Не выбрано"
                      calendarStartDay={1}
                    />
                    {(formWasSent && dateError) ? (
                      <div className="input-text">Выберите дату</div>
                    ) : false}
                  </div>
                </div>

                {/* Фильтры, если их нет, блок остается пустым */}
                <div className="filters-block">
                  {/* Тип отчета "Количество клиентов по статусам" */}
                  {(type === 'clientsonline') ? (
                    <React.Fragment>
                      <div className="filters-list-header">Тип клиента</div>
                      {(filterdata.userTags.length !== 0) ? 
                        <React.Fragment>
                          <div className="filters-list">
                            {filterdata.userTags.map(this.renderUserTags)}
                            <div className="checkboxes-btns">
                              <button type="button" onClick={() => this.onSwitchAllUserTags(true)}>
                                Выделить все
                              </button>
                              <button type="button" onClick={() => this.onSwitchAllUserTags(false)}>
                                Очистить все
                              </button>
                            </div>
                          </div>
                          {(formWasSent && userTagsError) ? (
                            <div className="filters-list-error">Выберите тип клиента</div>
                          ) : false}
                        </React.Fragment>
                      : false}
                    </React.Fragment>
                  ) : false}

                  {/* Тип отчета "Информация по ленте" */}
                  {(type === 'feedstat') ? (
                    <React.Fragment>
                      <div className="filters-list-header">Тип контента</div>
                      {(filterdata.contentTypes.length !== 0) ? 
                        <React.Fragment>
                          <div className="filters-list">
                            {filterdata.contentTypes.map(this.renderContentTypes)}
                            <div className="checkboxes-btns">
                              <button type="button" onClick={() => this.onSwitchAllContentTypes(true)}>
                                Выделить все
                              </button>
                              <button type="button" onClick={() => this.onSwitchAllContentTypes(false)}>
                                Очистить все
                              </button>
                            </div>
                          </div>
                          {(formWasSent && contentTypesError) ? (
                            <div className="filters-list-error">Выберите тип контента</div>
                          ) : false}
                        </React.Fragment>
                      : false}
                    </React.Fragment>
                  ) : false}
                </div>


                <div className="form-row special">
                  <button
                    type="button"
                    className="btn btn-green btn-spinner"
                    onClick={() => this.onSubmitForm()}
                  >
                    {reportLoading ? ( <SvgSpinner /> ) : ( <span>Скачать</span> )}
                    
                  </button>
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : false}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequireAuth(Analytics));
